import React from 'react';
import { isSafari } from '~utils/helpers';
import Block from '~routes/main/userprofile/block';
import PersonalDataLoader from '~routes/main/userprofile/tab-settings/personal-data/loader';
// import NotificationSettingsLoader from '~routes/main/userprofile/tab-settings/notification-settings/loader';

function TabSettingsLoader() {
    const windowWidth = isSafari() ? document.documentElement.clientWidth : window.innerWidth;
    const isMobile = windowWidth < 1160;
    return (
        <div className="settings-tab">
            <Block>
                <PersonalDataLoader isMobile={isMobile} />
            </Block>
            {/* <Block>
                <NotificationSettingsLoader isMobile={isMobile}/>
            </Block> */}
        </div>
    );
}

export default TabSettingsLoader;
export { TabSettingsLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-settings/loader/index.js